import { useState, useEffect } from 'react';
import api from '../utils/api';
import { logger } from '../utils/logger';

interface SignatureData {
  signatureTypes: string[];
  signatureLocations: string[];
  loading: boolean;
  error: string | null;
}

export const useSignatureData = () => {
  const [state, setState] = useState<SignatureData>({
    signatureTypes: [],
    signatureLocations: [],
    loading: true,
    error: null,
  });

  useEffect(() => {
    const loadSignatureData = async () => {
      try {
        // Use managed API client (automatic token handling)
        const [typesResponse, locationsResponse] = await Promise.all([
          api.get('/api/getty/signatures/types'),
          api.get('/api/getty/signatures/locations')
        ]);

        const typesData = typesResponse.data;
        const locationsData = locationsResponse.data;

        setState({
          signatureTypes: typesData.items || [],
          signatureLocations: locationsData.items || [],
          loading: false,
          error: null,
        });
      } catch (error) {
        logger.error('Failed to load signature data', error);
        setState(prev => ({
          ...prev,
          loading: false,
          error: 'Failed to load signature data',
        }));
      }
    };

    loadSignatureData();
  }, []);

  return state;
};
